import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import axios from '../../axios';
import * as url from '../../utils/url';
import { toastContainer } from '../../utils/toast';
import './start-chat.css';

const StartChat = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const phoneNumber = urlParams.get('phone') || '';
    const orgId = urlParams.get('orgId') || '';
    const hasPhone = phoneNumber.trim().length > 0;

    // Clean phone number for SMS link — use E.164 format (+1) so it matches Twilio's outbound format
    var digitsOnly = phoneNumber.replace(/\D/g, '');
    var cleanPhone = digitsOnly.length === 10 ? '+1' + digitsOnly : (digitsOnly.startsWith('1') && digitsOnly.length === 11 ? '+' + digitsOnly : '+' + digitsOnly);

    const [hashtags, setHashtags] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios.get(url.publicListTextifyGroups, { params: { orgId: orgId } })
            .then(function(res) {
                var items = (res.data && res.data.items) || [];
                var formatted = items.map(function(item) {
                    return {
                        id: item._id,
                        name: item.groupName && item.groupName.startsWith('#')
                            ? item.groupName.slice(1)
                            : (item.groupName || ''),
                        description: item.description || '',
                    };
                });
                setHashtags(formatted);
            })
            .catch(function(err) {
                console.error('[StartChat] Error loading hashtag groups:', err);
                setError('Unable to load hashtag groups.');
            })
            .finally(function() {
                setLoading(false);
            });
    }, []);

    const handleCopy = () => {
        navigator.clipboard.writeText(cleanPhone);
        toastContainer('Copied to clipboard', 'success');
    };

    return (
        <div className="start-chat-screen">
            <Container className="start-chat-container">
                <h1 className="start-chat-title">Start a chat via text</h1>
                {hasPhone ? (
                    <>
                        <p className="start-chat-subtitle">
                            Click below or text the number to start your chat. <strong>NOTE</strong> Your chat must begin with one of the active hashtags listed below to be routed appropriately.
                        </p>
                        <a href={`sms:${cleanPhone}`} className="text-button">
                            Text {phoneNumber}
                        </a>
                        <button className="copy-button" onClick={handleCopy}>
                            Copy number
                        </button>
                    </>
                ) : (
                    <p className="start-chat-subtitle">
                        Scan the QR code or follow the link provided by your company to start a chat.
                    </p>
                )}

                <div className="hashtag-card-container">
                    <h2 className="hashtag-card-title">Choose a hashtag</h2>
                    <div className="hashtag-list">
                        {loading ? (
                            <div className="hashtag-loading">Loading...</div>
                        ) : error ? (
                            <div className="hashtag-error">{error}</div>
                        ) : hashtags.length === 0 ? (
                            <div className="hashtag-empty">No hashtag groups available.</div>
                        ) : (
                            hashtags.map((h) => (
                                <div key={h.id} className="hashtag-item">
                                    <div className="hashtag-name-wrapper">
                                        <span className="hashtag-symbol">#</span>
                                        <span className="hashtag-name">{h.name.toLowerCase()}</span>
                                    </div>
                                    {h.description && (
                                        <div className="hashtag-description">{h.description}</div>
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                </div>

                <div className="start-chat-footer">
                    <p>You'll receive a confirmation after your first message.</p>
                </div>
            </Container>
        </div>
    );
};

export default StartChat;
